import { gql } from '@apollo/client';
import { WAREHOUSE_PLANNING_ENTRY_CONFIG_FIELDS, WarehousePlanningEntryConfigType, EntryNodeOptionType } from '../types/WarehousePlanningEntryConfigTypes';

export const GET_WAREHOUSE_PLANNING_ENTRY_CONFIGS = gql`
    query GetWarehousePlanningEntryConfigs($filters: WarehousePlanningEntryConfigFiltersInput) {
        configs: getAllWarehousePlanningEntryConfigs(filters: $filters) {
            ...WarehousePlanningEntryConfigFields
        }
    }
    ${WAREHOUSE_PLANNING_ENTRY_CONFIG_FIELDS}
`;

export const GET_AVAILABLE_ENTRY_NODES = gql`
    query GetAvailableEntryNodes($pushMode: Int) {
        entryNodes: getAvailableEntryNodes(pushMode: $pushMode) {
            value
            description
        }
    }
`;

export type { WarehousePlanningEntryConfigType, EntryNodeOptionType };

export interface WarehousePlanningEntryConfigFiltersInput {
    warehouseId?: number;
    entryNode?: string;
    isActive?: boolean;
}

export interface GetWarehousePlanningEntryConfigsResponse {
    configs: WarehousePlanningEntryConfigType[];
}

export interface GetAvailableEntryNodesResponse {
    entryNodes: EntryNodeOptionType[];
}

